import React from 'react';

const DeliveryPersonModal = ({ delivery }) => {
  const {
    showDeliveryPersonModal, editingDeliveryPerson, deliveryPersonForm, setDeliveryPersonForm,
    closeDeliveryPersonModal, handleCreateDeliveryPerson, handleUpdateDeliveryPerson,
  } = delivery;

  if (!showDeliveryPersonModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-2xl font-bold text-gray-800">
              {editingDeliveryPerson ? 'Edit Delivery Person' : 'Add Delivery Person'}
            </h3>
            <button onClick={closeDeliveryPersonModal} className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={editingDeliveryPerson ? handleUpdateDeliveryPerson : handleCreateDeliveryPerson}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                <input
                  type="text"
                  required
                  value={deliveryPersonForm.fullName}
                  onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, fullName: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
                <input
                  type="tel"
                  required
                  value={deliveryPersonForm.phone}
                  onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, phone: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  value={deliveryPersonForm.email}
                  onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, email: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">License Number</label>
                <input
                  type="text"
                  value={deliveryPersonForm.licenseNumber}
                  onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, licenseNumber: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Vehicle Type</label>
                <input
                  type="text"
                  value={deliveryPersonForm.vehicleType}
                  onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, vehicleType: e.target.value })}
                  placeholder="e.g., Bike, Car, Motorcycle"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Vehicle Number</label>
                <input
                  type="text"
                  value={deliveryPersonForm.vehicleNumber}
                  onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, vehicleNumber: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Coverage Zones (comma-separated)</label>
                <input
                  type="text"
                  value={Array.isArray(deliveryPersonForm.coverageZones) ? deliveryPersonForm.coverageZones.join(', ') : deliveryPersonForm.coverageZones}
                  onChange={(e) => {
                    const zones = e.target.value.split(',').map((z) => z.trim()).filter(Boolean);
                    setDeliveryPersonForm({ ...deliveryPersonForm, coverageZones: zones });
                  }}
                  placeholder="e.g., Nairobi, Mombasa, Kisumu"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                />
              </div>

              <div>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={deliveryPersonForm.isActive}
                    onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, isActive: e.target.checked })}
                    className="w-4 h-4 text-[#d44100] border-gray-300 rounded focus:ring-[#d44100]"
                  />
                  <span className="text-sm font-medium text-gray-700">Active</span>
                </label>
              </div>

              <div>
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={deliveryPersonForm.isAvailable}
                    onChange={(e) => setDeliveryPersonForm({ ...deliveryPersonForm, isAvailable: e.target.checked })}
                    className="w-4 h-4 text-[#d44100] border-gray-300 rounded focus:ring-[#d44100]"
                  />
                  <span className="text-sm font-medium text-gray-700">Available</span>
                </label>
              </div>
            </div>

            <div className="flex items-center justify-end space-x-4 mt-6 pt-6 border-t">
              <button type="button" onClick={closeDeliveryPersonModal} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
                Cancel
              </button>
              <button type="submit" className="px-6 py-2 bg-[#d44100] text-white rounded-lg hover:bg-[#b83700]">
                {editingDeliveryPerson ? 'Update' : 'Create'} Delivery Person
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPersonModal;
